import React, { useEffect, useRef, useState } from "react";
import * as R from "ramda";
import { Activity } from "./services/activity";
import { Pension } from "./services/pension";
import { OtherActivity } from "./services/otherActivity";
import { Tenant } from "./services/tenant";
import { DefaultService } from "./services/defaultService";
import { BranchService } from "./services/branchService";
import { EmptyState } from "./emptyState";
import { Ehpad } from "./services/ehpad";

import { ServiceNavbar } from "./serviceNavbar";
import { ModalServiceWarning } from "./modalServiceWarning";

import { ConnectionTypes, CommonServices, PersonalServices, AuxiliarOptions, OtherService, convertConnectionTypesToServiceType, isSocialNetwork, isInsurance } from "../../../../../constants/utils/connectionTypes";

export const ServicesEdit = ({ userId, user, selectedUserConnection, activeUserConnections, displayComments, disableModifications, serviceDatas, isLoading, generateLetters }) => {
	const serviceModalRef = useRef(null);
	const [selectedService, setSelectedService] = useState(undefined);
	const [matchingServiceDatas, setMatchingServiceDatas] = useState([]);
	const [showCompleteState, setShowCompleteState] = useState(false);
	const [favoriteServices, setFavoriteServices] = useState([]);
	const [allServicesFilled, setAllServicesFilled] = useState(false);

	if (R.isNil(displayComments)) {
		displayComments = true;
	}

	if (R.isNil(disableModifications)) {
		disableModifications = false;
	}

	useEffect(() => {
		if ((R.isNil(selectedUserConnection) || !activeUserConnections.some((a) => a.connectionType === selectedUserConnection.connectionType))/* && !allServicesFilled*/) {
			const sortedActiveCommonServices = R.sortWith([R.ascend(R.prop("title"))])(Object.values(CommonServices).filter((sr) => activeUserConnections.findIndex((r) => r.connectionType === sr.connectionType) !== -1));
			setSelectedService(sortedActiveCommonServices[0]);
		}
	}, [activeUserConnections]);

	useEffect(() => {
		if (!R.isNil(selectedUserConnection)) {
			setSelectedService(selectedUserConnection);
		}
	}, [selectedUserConnection]);

	useEffect(() => {
		if (!R.isNil(selectedService)) {
			setMatchingServiceDatas(serviceDatas.filter((s) => s.serviceType === convertConnectionTypesToServiceType(selectedService.connectionType)));
			setShowCompleteState(false);
		}
	}, [selectedService]);

	useEffect(() => {
		let allCompleted = true;
		setAllServicesFilled(true);
		Object.values(CommonServices)
			.concat(Object.values(PersonalServices))
			.concat(Object.values(AuxiliarOptions))
			.concat(Object.values(OtherService))
			.filter((u) => activeUserConnections.some((i) => (isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType : isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType)))
			.map((srv) => {
				if (favoriteServices.indexOf(srv.connectionType) == -1 && !serviceDatas.some((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType))) {
					allCompleted = false;
				}
			});
		if (!R.isNil(selectedService)) {
			setMatchingServiceDatas(serviceDatas.filter((s) => s.serviceType === convertConnectionTypesToServiceType(selectedService.connectionType)));
		}

		// if (!R.isNil(selectedService) && activeUserConnections.length > 0) {
		// 	setSelectedService(activeUserConnections[0]);
		// }
		
		setShowCompleteState(allCompleted);
		setAllServicesFilled(allCompleted);
	}, [serviceDatas, favoriteServices, activeUserConnections]);


	useEffect(() => {
		if (allServicesFilled) {
			setShowCompleteState(true);
		}
	}, [allServicesFilled]);


	return (
		<React.Fragment>
			<div className="modal fade px-0" id="servicesEdit" aria-labelledby="servicesEditLabel" aria-hidden="true" ref={serviceModalRef}>
				<div className="modal-dialog px-2 modal-dialog-scrollable container-modal">
					<div className="modal-content bg-light">
						<div className="modal-header">
							<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">Services</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 font-weight-demi text-primary mb-0 ls-n1 lh-1 mx-auto" id="infoValiderLabel">
										VEUILLEZ COMPLETER 100 % DES SERVICES SELECTIONNÉS OU METTRE EN FAVORIS POUR ACCEDER À L’ESPACE COURRIERS <br />
										sinon les supprimer afin de les ajouter plus tard
									</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" aria-label="Close" data-dismiss="modal">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						</div>
						<div className="modal-body scroll-default no-auto-overflow pt-0">
							<div className="grid grid-1 grid-auto-row grid-auto-aside grid-auto-scroll">
								<ServiceNavbar selectedService={selectedService} setSelectedService={setSelectedService} activeUserConnections={activeUserConnections} serviceDatas={serviceDatas} userId={userId} favoriteServices={favoriteServices} setFavoriteServices={setFavoriteServices} setShowCompleteState={setShowCompleteState} generateLetters={generateLetters} />
								<section className="block">
									<h2 className="sr-only visually-hidden">Services setup</h2>
									{(() => {
										if (showCompleteState && !generateLetters) {
											return <EmptyState user={user} userId={userId} isLoading={isLoading} />;
										}

										if (R.isNil(selectedService)) return "";

										// if(R.isNil(selectedServiceOption))
										// 	return '';

										switch (selectedService.connectionType) {
											case ConnectionTypes.bank:
												return <BranchService connectionType={ConnectionTypes.bank} title="Banque" userId={userId} serviceDatas={matchingServiceDatas} isLoading={isLoading} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters} />;

											case ConnectionTypes.sport:
												return <BranchService connectionType={ConnectionTypes.sport} title="Sport" userId={userId} serviceDatas={matchingServiceDatas} isLoading={isLoading} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters} />;

											case ConnectionTypes.activity:
												return <Activity userId={userId} serviceDatas={matchingServiceDatas} disableModifications={disableModifications} generateLetters={generateLetters} />;

											case ConnectionTypes.pension:
												return <Pension userId={userId} serviceDatas={matchingServiceDatas} disableModifications={disableModifications} generateLetters={generateLetters} />;

											case ConnectionTypes.otherActivity:
												return <OtherActivity userId={userId} serviceDatas={matchingServiceDatas} disableModifications={disableModifications} generateLetters={generateLetters} />;

											case ConnectionTypes.locataire:
												return <Tenant userId={userId} serviceDatas={matchingServiceDatas} disableModifications={disableModifications} generateLetters={generateLetters} />;

											case ConnectionTypes.ehpad:
												return <Ehpad userId={userId} serviceDatas={matchingServiceDatas} disableModifications={disableModifications} generateLetters={generateLetters} />;

											default:
												return <DefaultService selectedService={selectedService} serviceDatas={matchingServiceDatas} isLoading={isLoading} userId={userId} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters} />;
										}
									})()}
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ModalServiceWarning></ModalServiceWarning>
		</React.Fragment>
	);
};
